'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var device_context = require('./device.context-f96381a3.js');

var useDeviceContext = function () { return React.useContext(device_context.DeviceContext); };
var useIsSmallViewportWidth = function () {
    var isSmallViewport = useDeviceContext().isSmallViewport;
    return isSmallViewport;
};
var useIsMobileDevice = function () {
    var isMobileDevice = useDeviceContext().isMobileDevice;
    return isMobileDevice;
};
var useIsMobileView = function () {
    var _a = useDeviceContext(), isSmallViewport = _a.isSmallViewport, isMobileDevice = _a.isMobileDevice;
    return isSmallViewport || isMobileDevice;
};

exports.useDeviceContext = useDeviceContext;
exports.useIsMobileDevice = useIsMobileDevice;
exports.useIsMobileView = useIsMobileView;
exports.useIsSmallViewportWidth = useIsSmallViewportWidth;
